module.exports = __webpack_public_path__ + "img/world-map-with-tags.e2c48214.png";